export default __webpack_public_path__ + "static/media/embed-img_mobile.d473544a.png";